import React from 'react'
import image from '../assets/banner/banner.png'

const HomeImage = () => {
  return (
<div className="container mx-auto px-4 sm:px-6 lg:px-10 py-6">
  <div className="relative w-full h-[240px] sm:h-[300px] md:h-[360px] lg:h-[450px] rounded-lg overflow-hidden">

    {/* Background Image */}
    <img
      src={image}
      alt="Samartha Ornaments Jewelry"
      className="absolute inset-0 w-full h-full object-cover"
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black/10"></div>

    {/* Text Content */}
    <div className="absolute inset-0 flex items-center">
      <div className="px-4 sm:px-8 md:px-12 max-w-xl">

        {/* Tagline */}
        <p className="
            font-serif 
            text-lg 
            sm:text-xl 
            md:text-2xl 
            lg:text-4xl 
            xl:text-5xl 
            leading-snug 
            text-[#5a3620]
        ">
          Shine Bright <br/>With Samartha
        </p>

        {/* Heading */}
        <h1 className="
            text-xs 
            sm:text-sm 
            md:text-base 
            lg:text-lg 
            tracking-wide 
            text-[#7a4a2e] 
            mb-2
        ">
          Jewelry And Hair Accessories<br />
        </h1>

  

      </div>
    </div>

  </div>
</div>
  )
}

export default HomeImage